import React, { Component } from 'react';
import styled from 'styled-components';
import Title from '../../components/Title';
import Layout from '../../components/Layout';
import { colors } from '../../styles/colors';
import SearchReservationForm from './SearchReservationForm';
import { devices } from '../../styles/breakpoints';
import canceledIllustration from '../../images/canceled-flight.svg';
import { MediaQuery } from '../../components/MediaQuery';
import { Box } from '../../components/Flex';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;

  @media ${devices.desktop} {
    max-width: 1170px;
    margin: 0 auto;

    ${Box} {
      margin-top: 48px;
    }

    ${MediaQuery} {
      flex: 1;

      img {
        margin: 0 auto;
      }
    }
  }
`;

const Text = styled.p`
  font-size: 16px;
  color: ${colors.GRAY_DARKEST};
  margin-top: 18px;

  @media ${devices.desktop} {
    font-size: 20px;
  }
`;

const FormWrapper = styled.div`
  flex: 1;
`;

export default class SearchReservation extends Component {
  render() {
    const { history } = this.props;
    return (
      <Layout>
        <Container>
          <Title>Alteração de voo</Title>
          <Box justifyContent="space-between">
            <FormWrapper>
              <Text>Insira os dados abaixo para buscar sua reserva</Text>
              <SearchReservationForm history={history} />
            </FormWrapper>

            <MediaQuery device={devices.desktop}>
              <img
                src={canceledIllustration}
                alt="Ilustração - voo cancelado"
              />
            </MediaQuery>
          </Box>
        </Container>
      </Layout>
    );
  }
}
